/**
 * api fetch
 */

 import { toMulipartedForm } from './form';

// get
export function get(url) {
  const method = "GET";
  const headers = {
    'Accept': 'application/json'
  };
  return fetch(url, {method, headers})
    .then((res)=> res.json())
    .catch(console.error);
}

/**
 * post
 * multipart/form-data で送信
 */
export function post(url, payload) {
  const method = "POST";
  const body = toMulipartedForm(payload);
  const headers = {
    'Accept': 'application/json'
  };
  return fetch(url, {method, headers, body})
    .then((res) => res.json())
    .catch((e) => {
      throw new Error(body || "リクエストに失敗しました")
    });
}



// WEBPACK FOOTER //
// ./src/helper/api.js